// product-pairings.js — carousel navigation + Add to Cart

(function () {
  'use strict';

  // ── Carousel ────────────────────────────────────────────────────────────────
  function initCarousel(wrap) {
    const track = wrap.querySelector('.pairings-track');
    const prev  = wrap.querySelector('.pairings-arrow--prev');
    const next  = wrap.querySelector('.pairings-arrow--next');
    if (!track || (!prev && !next)) return;

    function cardWidth() {
      const card = track.querySelector('.pairings-card');
      if (!card) return 200;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      const atStart = track.scrollLeft <= 2;
      const atEnd   = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });

    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    // Re-check on resize (card widths change at breakpoints)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 150);
    });

    updateArrows();
  }

  // ── Add to Cart ─────────────────────────────────────────────────────────────
  function initATC(wrap) {
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.pairings-card__atc[data-variant-id]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var variantId = btn.dataset.variantId;
      var original  = btn.textContent.trim();

      btn.classList.add('is-adding');
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept':        'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add failed');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';

        // Notify the theme to refresh cart count / drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Dawn / Debut themes listen for this:
        document.dispatchEvent(new CustomEvent('cart-update'));

        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
          btn.textContent = original;
        }, 2000);
      })
      .catch(function () {
        btn.classList.remove('is-adding');
        btn.classList.add('is-error');
        btn.textContent = 'Error — retry';

        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.disabled = false;
          btn.textContent = original;
        }, 3000);
      });
    });
  }

  // ── Init ────────────────────────────────────────────────────────────────────
  function boot() {
    document.querySelectorAll('.product-pairings').forEach(function (wrap) {
      initCarousel(wrap);
      initATC(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();